import React from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Roles from "../components/Roles";

const RoleManagement = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Roles" />

        {/* DashBoardLayerSix */}
        <Roles />



      </MasterLayout>
    </>
  );
}
export default RoleManagement;